import React from 'react';

const CLUBS = [
  { name: 'BADTri', wordmark: 'BADTRI', url: 'https://www.badtri.org', logo: '/images/badtri.png' },
  { name: '3cTri', wordmark: '3CTRI', url: 'https://www.3ctri.org.uk' },
  { name: 'KingswoodTri', wordmark: 'KINGSWOODTRI', url: 'https://kingswoodtri.com' },
];

/** Trust strip — source: mockup L290–300 (real clubs only; grey placeholders omitted). */
const TrustStrip = (): React.JSX.Element => (
  <section className="oq-trust">
    <div className="oq-trust__inner">
      <span className="oq-trust__label oq-bebas">TRUSTED BY UK ENDURANCE &amp; MULTISPORT CLUBS</span>
      {CLUBS.map(({ name, wordmark, url, logo }) => (
        <a key={name} href={url} className="oq-trust__club" target="_blank" rel="noopener noreferrer">
          {logo && <img src={logo} alt={name} width={30} height={30} className="oq-trust__club-logo" />}
          <span className="oq-trust__wordmark oq-bebas">{wordmark}</span>
        </a>
      ))}
    </div>
  </section>
);

export default TrustStrip;
